<router-outlet></router-outlet>

<!-- Tour Global -->
<app-tour></app-tour>
